var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-list"},_vm._l((_vm.tagList),function(item){return _c('div',{key:item.id,class:[item.checked ? 'item active' : 'item'],on:{"click":function($event){return _vm.toggleCheckTag(item.id)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }